<template>
	<div>
		<div class="font-size-md font-weight-600">Name your mapping block</div>
		<div class="font-size-xs mt-1 mb-4">
			Try the plural name of the item type.
			<!-- If you're not sure, leave empty -->
		</div>
		<div class="font-size-md font-weight-500">Mapping block name</div>
		<AppTextField outlined dense v-model="localTitle" hide-details single-line />
	</div>
</template>

<script>
export default {
	name: 'MapperTitleEditor',
	props: {
		existingTitle: { type: String },
	},
	computed: {
		localTitle: {
			get() {
				return this.existingTitle;
			},
			set(value) {
				if (value !== this.existingTitle) {
					this.saveTitle(value);
				}
			},
		},
	},
	methods: {
		saveTitle(title) {
			this.$emit('set-title', title);
		},
	},
};
</script>

<style lang="scss" scoped></style>
